module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAALCAYAAACprHcmAAAAkklEQVQYlZXQoQ6BURgG4Oefk0VRElyIa/mZqHABNlN07kAVbf4oappimplAsBmb4ATh/MyXvu17zrt3J8vzfIkNrhijLj2PgENEfVTRKsH3gG2EC5wxK8ECJmXHFJ7GvcD8F36iixFWGCJL2EtAJaYXOKHzLbn9T+ceat6/sf6FGx+dd/Fxam4Bzdh5jyMGZckv0ZgeUkfik34AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/back/nav/list.png
// module id = Okyk
// module chunks = 1